"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_SPACE_NAME_MAX = void 0;
exports.suggestChatSpaceName = suggestChatSpaceName;
exports.fetchContractChatSpaces = fetchContractChatSpaces;
exports.fetchChatSpacesForProject = fetchChatSpacesForProject;
exports.createContractChatSpace = createContractChatSpace;
exports.attachContractChatSpace = attachContractChatSpace;
exports.detachContractChatSpace = detachContractChatSpace;
exports.inviteContractChatMembers = inviteContractChatMembers;
exports.describeMemberState = describeMemberState;
/**
 * Pokoje Google Chat kontraktów ENVI — warstwa HTTP i reguły czyste (bez Reacta).
 *
 * Backend: PS-nodeJS src/contracts/chatSpaces/ChatSpacesRouters.ts
 *   GET    {PS_API}contract/:id/chatSpaces   lista pokoi (najpierw pokoje projektu kontraktu)
 *   POST   {PS_API}contract/:id/chatSpace    { scope, displayName? } zakłada pokój
 *   PUT    {PS_API}contract/:id/chatSpace    { chatSpaceId } podpina istniejący
 *   DELETE {PS_API}contract/:id/chatSpace    odpina (pokój w Google zostaje)
 *   POST   {PS_API}contractReact             pole _chatSpaceSelection przy tworzeniu kontraktu
 *
 * Fetch idzie przez ToolsFetch (jak contractTemplatesTreeService): 401 kończy się
 * przejściem do logowania, a błędy serwera wracają jako czytelny komunikat.
 */
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const ToolsFetch_1 = __importDefault(require("../../../React/Tools/ToolsFetch"));
exports.CHAT_SPACE_NAME_MAX = 128;
const JSON_HEADERS = { "Content-Type": "application/json" };
/** Podpowiedź nazwy pokoju: `<oznaczenie> <alias albo nazwa>`, max 128 znaków — ta sama reguła co na serwerze. */
function suggestChatSpaceName(ourId, alias, name) {
    const label = (alias || "").trim() || (name || "").trim();
    return `${ourId ?? ""} ${label}`.trim().slice(0, exports.CHAT_SPACE_NAME_MAX);
}
async function fetchContractChatSpaces(contractId) {
    return ToolsFetch_1.default.fetchJsonWithSafeError(`${MainSetupReact_1.default.serverUrl}contract/${contractId}/chatSpaces`, {
        method: "GET",
        credentials: "include",
    });
}
/**
 * Lista pokoi dla kontraktu, który jeszcze nie istnieje (okno nowego kontraktu):
 * `GET /chatSpaces?projectOurId=`. Przy błędzie (np. brak uprawnień) zwraca `null`,
 * a formularz wtedy nie pokazuje wyboru „Istniejący pokój".
 */
async function fetchChatSpacesForProject(projectOurId) {
    try {
        const list = await ToolsFetch_1.default.fetchJsonWithSafeError(`${MainSetupReact_1.default.serverUrl}chatSpaces?projectOurId=${encodeURIComponent(projectOurId)}`, { method: "GET", credentials: "include" });
        return Array.isArray(list) ? list : null;
    }
    catch {
        return null;
    }
}
async function createContractChatSpace(contractId, scope, displayName, personIds) {
    return ToolsFetch_1.default.fetchJsonWithSafeError(`${MainSetupReact_1.default.serverUrl}contract/${contractId}/chatSpace`, {
        method: "POST",
        headers: JSON_HEADERS,
        credentials: "include",
        body: JSON.stringify({ scope, displayName: displayName?.trim() || undefined, personIds }),
    });
}
async function attachContractChatSpace(contractId, chatSpaceId) {
    const result = await ToolsFetch_1.default.fetchJsonWithSafeError(`${MainSetupReact_1.default.serverUrl}contract/${contractId}/chatSpace`, {
        method: "PUT",
        headers: JSON_HEADERS,
        credentials: "include",
        body: JSON.stringify({ chatSpaceId }),
    });
    return result.chatSpace;
}
async function detachContractChatSpace(contractId) {
    await ToolsFetch_1.default.fetchJsonWithSafeError(`${MainSetupReact_1.default.serverUrl}contract/${contractId}/chatSpace`, {
        method: "DELETE",
        credentials: "include",
    });
}
async function inviteContractChatMembers(contractId, personIds) {
    return ToolsFetch_1.default.fetchJsonWithSafeError(`${MainSetupReact_1.default.serverUrl}contract/${contractId}/chatSpace/members`, {
        method: "POST",
        headers: JSON_HEADERS,
        credentials: "include",
        body: JSON.stringify({ personIds }),
    });
}
/** Opis stanu członka po założeniu pokoju. INVITED to NIE „dodano". */
function describeMemberState(member) {
    switch (member.state) {
        case "JOINED":
            return "dodano do pokoju";
        case "INVITED":
            return "zaproszenie wysłane (osoba z kontem Gmail musi je przyjąć)";
        default:
            return `nie udało się dodać${member.error ? `: ${member.error}` : ""}`;
    }
}
